import { isCloudhouseHost } from './routing';

// Where a product card's Open link should point. Products are served on the org's own host
// (org-edge routes per-tenant), so a relative path is only right when the browser is already
// on that host. On any other production host — notably a user parked on hub while their org
// host provisions — the link must be absolute to the org host, and with no org slug there is
// no valid destination at all (null = render no link). Dev hosts keep the relative path.
export function productHref(
  path: string | undefined,
  orgSlug: string | null | undefined,
  hostname: string,
): string | null {
  if (!path) return null;
  if (!isCloudhouseHost(hostname)) return path;
  if (!orgSlug) return null;
  const orgHost = `${orgSlug.toLowerCase()}.cloudhouse.com`;
  return hostname.toLowerCase() === orgHost ? path : `https://${orgHost}${path}`;
}
